function normalizeField(key, val, pathPrefix) {
    return {
        path  : key,
        type  : val.type || 'real',
        fields: typeof val === 'string' ? [key] : val.fields || [],
        get   : val.get || (state => _.get(state, pathPrefix + key)),
        set   : val.set || ((state, value) => _.set(state, pathPrefix + key, value)),
        label : typeof val === 'string' ? val : val.label || key
    }
}

const fields = {
    'model.reservation.first_name'               : 'First name',
    'model.reservation.last_name'                : 'Last name',
    'model.reservation.country'                  : 'Country',
    'model.reservation.phone'                    : 'Mobile phone',
    'model.reservation.email'                    : 'Email',
    'model.reservation.email_confirmation'       : 'Confirm email',
    'model.reservation.address_primary'          : 'Primary Address',
    'model.reservation.city'                     : 'City',
    'model.reservation.state'                    : 'State',
    'model.reservation.zip'                      : 'Zip',
    'model.reservation.province'                 : 'Province',
    'model.reservation.additional_info'          : 'Province',
    'model.reservation.postal_code'              : 'Postal code',
    'model.reservation.is_international_customer': 'Is International customer?',
    'model.reservation.reservees_number'         : 'Number of renters',
    'model.reservation.date_pickup'              : 'Start Date',
    'model.reservation.date_return'              : 'End Date',
    'model.reservation.delivery_in_shop'         : 'In Shop Fitting/Delivery Later ($5.00 per person)',
    'model.reservation.referral_id'              : 'Referral Id',
}


Object.keys(fields).forEach(key => fields[key] = normalizeField(key, fields[key]));
export default fields;
